import {ChangeDetectorRef, Component, Input, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from "@angular/material/snack-bar";
import {MatPaginator} from "@angular/material/paginator";
import {ConfirmService} from "../services/confirm.service";
import {switchMap, toArray} from "rxjs/operators";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {EditJobalertComponent} from "../edit-jobalert/edit-jobalert.component";
import {EncryptDecryptService} from "../services/encrypt-decrypt.service";
import {AddExperienceComponent} from "../add-experience/add-experience.component";
import {AddJobalertComponent} from "../add-jobalert/add-jobalert.component";
import swal from 'sweetalert2';

@Component({
  selector: 'app-jobalert',
  templateUrl: './jobalert.component.html',
  styleUrls: ['./jobalert.component.css']
})
export class JobalertComponent implements OnInit {

  @Input() id: number;
  @Input() name: string;
  @Input() poste: string;
  @Input() _mail: string;

  apikey: string;
  user: any;
  jsonData: string;
  fonctionName: Fonction[];
  ContratName: Contrat[];
  regionName: Region[];

  fstring: string;
  region: Region[] = [];
  emploiFonction: Fonction[] = [];
  posteContrat: Contrat[] = [];

  mouseOvered = false;

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  private editJobalertComponent = EditJobalertComponent;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  _nContrat: any[] = [];
  dsData: any;
  rows: JobAlert[] = [];
  dataSource = new MatTableDataSource(this.rows);
  displayedColumns = ['id', 'name', 'mail', 'fonction', 'regions', 'age'];
  constructor(private encdec: EncryptDecryptService, public changeDetectorRefs: ChangeDetectorRef, public dialog: MatDialog, private confirmService: ConfirmService, private _snackBar: MatSnackBar, private http: HttpClient) {
  }

  ngOnInit(): void {
    this.apikey = localStorage.getItem('apikey');
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.getInfoJA();
    this.getInfoCand();
  }

  getInfoCand(){
    this.http.get('https://api.sitederecrutement.com/Home/getcandidate?apikey='+this.apikey+'&login='+this.user.candidat_api, { responseType: "text" }).subscribe(
      result => {

        const candidateInfo = JSON.parse(this.encdec.getDecrypt(result));
        this.rows = candidateInfo.alertes;

        this.dataSource.data = this.rows;
      }
    )
  }

  repl

  getInfoJA()
  {
    let resp: string = "";
    this.http.get('https://api.sitederecrutement.com/Home/getinfos?apikey='+this.apikey, { responseType: "text" }).subscribe(
      result => {
        this.jsonData = this.encdec.getDecrypt(result);
        let jsonObject: any = JSON.parse(this.jsonData);

        this.emploiFonction = jsonObject.fonctions;
        this.posteContrat = jsonObject.contrats;
        this.region = jsonObject.regions;
      }
    )
  }

  getContratName(rows) {
    let txtf = new Array();
    for(let id of rows)
    {
      txtf.push(this.posteContrat.find(d => d.idcontrat === Number(id)).contrat);
    }
    return txtf;
  }

  getFonctionName(rows) {
    let txtf = new Array();
    for(let id of rows)
    {
      txtf.push(this.emploiFonction.find(d => d.idfonction === Number(id)).fonction);
    }
    return txtf;
  }

  openDialogAdd() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-modalbox';

    const dialogRef = this.dialog.open(AddJobalertComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.changeDetectorRefs.detectChanges();
          this.getInfoCand();
        }
      }
    )
  }

  public editRecord(data: JobAlert) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {...data};
    dialogConfig.panelClass = 'custom-modalbox';

    const dialogRef = this.dialog.open(EditJobalertComponent, dialogConfig );

    dialogRef.afterClosed().subscribe(
      () => {
        this.changeDetectorRefs.detectChanges();
        this.getInfoCand();
      }
    )
  }

  onDelete(alertId: number){
    let obj: DeleteAlert = {
      idcandidat: this.user.idcandidat,
      idcandidat_jobalert: alertId,
      mail: null
    }
    let data = this.encdec.getEncrypt( JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    this.confirmService.confirm('Supprimer Job Alerte',
      'Voulez-vous supprimer cette job alerte ?').pipe(
        switchMap(res => {
          if (res === true) {
            return this.http.post('https://api.sitederecrutement.com/Home/updatealerte?apikey=' + this.apikey, formData, {responseType: "text"})
          }
        })
    ).subscribe(
      result => {
        if(result)
          this.deleteRowDataTable(alertId, 'id', this.paginator, this.dataSource);
        swal.fire(
          {
            title: 'Supprimée',
            text: 'Votre Job Alerte a été supprimée !',
            icon: 'success',
            iconColor: 'd ',
            customClass: {
              confirmButton: "btn btn-rose",
            },
            buttonsStyling: false
          }
        ).then(() => {
          this.changeDetectorRefs.detectChanges();
        })
      },
      (error => {
        console.log(error);
      })
    )

  }

  private deleteRowDataTable (recordId, idColumn, paginator, dataSource) {
    this.dsData = dataSource.data;
    const itemIndex = this.dsData.findIndex(obj => obj[idColumn] === recordId);
    dataSource.data.splice(itemIndex, 1);
    dataSource.paginator = paginator
  }

  onUpdate(formObj) {
    let values = formObj.value;
    let obj: NewJobAlert = {
      idcandidat: this.user.idcandidat,
      jobalert_nom: values.name,
      jobalert_fonction: this.fonctionName.map(d => d.fonction).toString(),
      jobalert_mail: values.mail,
      jobalert_region: this.regionName.map(c => c.region).toString()
    };

    // formattage data
    let data = this.encdec.getEncrypt( JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    //envoi des données
    this.http.post('https://api.sitederecrutement.com/Home/updatealerte?apikey=' + this.apikey, formData, {responseType: "text"}).subscribe(
      result => {
        this.getInfoCand();
        this.changeDetectorRefs.detectChanges();
      }
    );
    this._snackBar.open("La Job Alerte : " + this.name + " a bien été créée.", 'Fermer', {
      duration: 5000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    })
    formObj.reset();
  }
}

@Pipe({name: 'replaceLineBreaks'})
export class ReplaceLineBreaks implements PipeTransform {
  transform(value: string): string {
    return value.replace(',', '<br/>');
  }
}

interface NewJobAlert{
  idcandidat: string;
  jobalert_nom: string;
  jobalert_fonction: string;
  jobalert_mail: string;
  jobalert_region: string;
}

interface Region{
  idregion: number;
  region: string;
}

interface Contrat{
  idcontrat: number;
  contrat: string;
}

interface Fonction{
  idfonction: number;
  fonction: string;
}

interface DeleteAlert{
  idcandidat: string;
  idcandidat_jobalert: number;
  mail: string;
}

interface JobAlert{
  idcandidat_jobalert: number;
  jobalert_nom: string;
  jobalert_fonction: string;
  jobalert_mail: string;
  jobalert_region: string;
}
